module.exports = __webpack_public_path__ + "img/banner-tc4-m.0b3c162b.jpg";